/**
 * Section list selection helpers for master–detail template editors.
 */

export function nextSelectedIndexAfterRemoveSection(
  removedIndex: number,
  previousSelected: number | null,
  newLength: number,
): number | null {
  if (newLength <= 0) return null
  /** Do not open the section modal on remove if the user had not opened it. */
  if (previousSelected === null) return null
  if (removedIndex < previousSelected) return previousSelected - 1
  if (removedIndex === previousSelected) return Math.min(previousSelected, newLength - 1)
  return previousSelected
}

export function indexForNewSection(previousLength: number): number {
  return previousLength
}
